export default __webpack_public_path__ + "ebc7ffd04e6422dcae45469814bdfff8.png";